import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "../utils/page-title";

export const Route = createFileRoute("/")({
  head: () => pageHead("Human Design awareness", { canonicalPath: "/" }),
});
